/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { TimeUtils } from '@wit/vtv-x-foundation-lib';
import React from 'react';
import { NotificationProps } from 'types/components/Modal';

export default function ModalNotification({ text, onClose, duration }: NotificationProps) {
  setTimeout(() => {
    onClose();
  }, TimeUtils.secondsToMilliseconds(duration));

  return (
    <div className="modal-notification">
      <p id="Modal_notification">{text}</p>
      <div className="bar" />
      <div className="point" />
    </div>
  );
}
